// extracted by mini-css-extract-plugin
module.exports = {"button":"_103a151b99--button--FzUK3","icon":"_103a151b99--icon--yB9R1","XS":"_103a151b99--XS--JTpSd","M":"_103a151b99--M--TETjN"};